<template>
  <h2
    class="uppercase font-black text-sm tracking-[4px] pl-4 relative before:content-[''] before:absolute before:block before:-top-[1px] before:w-1 before:left-0 before:h-6 before:bg-cardinal-500"
  >
    <slot />
  </h2>
</template>
